import React from 'react';
import TextWinds from '../common/TextWinds';
import { Link } from 'react-router-dom';
import { PhotoIcon } from '@heroicons/react/24/outline';
import { Button, Card, CardBody, CardHeader } from '@material-tailwind/react';
import { CourseInfoType } from '../../constants/types';

interface CourseCardProps {
  data: CourseInfoType;
  isFromMainPage?: boolean;
}
const CourseCard = ({ data, isFromMainPage }: CourseCardProps) => {
  const path = isFromMainPage
    ? `./courses/${data.product_sub_type.toLowerCase()}/details/${data.id}`
    : `./details/${data.id}`;
  return (
    <Link to={path}>
      <Card className="m-auto h-full w-full shrink-0 xl:w-[270px]">
        <Button className="flex h-full flex-col bg-white p-0">
          <CardHeader className="mx-0 my-0 flex aspect-[210/120] w-full items-center justify-center rounded-sm bg-gray-100 p-0 shadow-none">
            {data.thumbnail?.access_url ? (
              <img
                className="h-full w-full rounded-t-lg object-contain"
                src={data.thumbnail?.access_url}
                alt={data.name}
              />
            ) : (
              <PhotoIcon className="h-[32px] w-[32px]" />
            )}
          </CardHeader>
          <CardBody className="w-full px-[10px] py-[16px]">
            <TextWinds type="content_body4" className="font-semibold">
              {data.name}
            </TextWinds>
            <TextWinds type="content_body4" color="gray7" className="pt-[8px]">
              {data.description}
            </TextWinds>
          </CardBody>
        </Button>
      </Card>
    </Link>
  );
};

export default CourseCard;
